import React, { useEffect, useRef } from "react";
import "./common.scss";
import Success from "../../assets/gif/success.gif";
import Error from "../../assets/gif/error.gif";

const PaymentModal = React.memo(
  ({ isOpen, title, children, type = "success" }) => {
    const modalRef = useRef(null);
    const previousFocusRef = useRef(null);

    // Focus management: save previous focus, auto-focus modal, restore on close
    useEffect(() => {
      if (isOpen) {
        previousFocusRef.current = document.activeElement;
        // Auto-focus first focusable element inside modal after render
        requestAnimationFrame(() => {
          const modal = modalRef.current;
          if (!modal) return;
          const first = modal.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
          if (first) first.focus();
        });
      } else if (previousFocusRef.current) {
        previousFocusRef.current.focus();
        previousFocusRef.current = null;
      }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
      <div className="payment-backdrop">
        <div
          ref={modalRef}
          className={`payment-container ${type}`}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
          // onClick={(e) => e.stopPropagation()}
          // onKeyDown={handleKeyDown}
        >
          <div className="payment-header-top">
            <div className="gif-show">
              {type === "success" ? (
                <img src={Success} alt="Success" />
              ) : (
                <img src={Error} alt="Error" />
              )}
            </div>
            <h4 className="payment-title bold" id="modal-title">
              {title}
            </h4>
          </div>
          <div className="payment-content">{children}</div>
        </div>
      </div>
    );
  },
);

PaymentModal.displayName = "PaymentModal";

export default PaymentModal;
